import has from "lodash/has";
import { buildUrl, getEnv } from "shared/utils";
import filterMenu from "shared/utils/filterMenu";
import { DESKTOP, MOBILE } from "shared/layout";

const { AUTH_URL, AUTH_CLIENT_ID, PROFILE_URL, SEARCH_URL } = getEnv();

const LP_URL = "https://www.lonelyplanet.com/";
const SHOP_URL = "https://shop.lonelyplanet.com/";
const VIDEO_URL = buildUrl(LP_URL, "video");
const COMMUNITY_URL = buildUrl(LP_URL, "thorntree");
const LPTV_URL = "https://tv.lonelyplanet.com";

const baseMenu = {
  items: [
    {
      layouts: [DESKTOP],
      title: "Search",
      url: SEARCH_URL,
    },
    {
      title: "Destinations",
      url: buildUrl(LP_URL, "places"),
      mobileOrder: 1,
      submenu: {
        featured: {
          image:
            "https://lp-cms-production.imgix.net/2020-11/BiT-OG-image.jpg?auto=format&fit=min&w=80&h=60&q=72",
          title: "Best in Travel 2021",
          subtitle: "Featured",
          url: buildUrl(LP_URL, "best-in-travel"),
        },
        items: [
          {
            title: "Africa",
            url: buildUrl(LP_URL, "africa"),
          },
          {
            title: "Antarctica",
            url: buildUrl(LP_URL, "antarctica"),
          },
          {
            title: "Asia",
            url: buildUrl(LP_URL, "asia"),
          },
          {
            title: "Australia & Pacific",
            url: buildUrl(LP_URL, "pacific"),
          },
          {
            title: "Caribbean",
            url: buildUrl(LP_URL, "caribbean"),
          },
          {
            title: "Central America",
            url: buildUrl(LP_URL, "central-america"),
          },
          {
            title: "Europe",
            url: buildUrl(LP_URL, "europe"),
          },
          {
            title: "Middle East",
            url: buildUrl(LP_URL, "middle-east"),
          },
          {
            title: "North America",
            url: buildUrl(LP_URL, "north-america"),
          },
          {
            title: "South America",
            url: buildUrl(LP_URL, "south-america"),
          },
        ],
        call_to_action: {
          url: buildUrl(LP_URL, "places"),
          title: "See All Countries",
        },
      },
    },
    {
      title: "Video",
      url: VIDEO_URL,
      mobileOrder: 2,
      submenu: {
        featured: {
          image:
            "https://lonelyplanetstatic.imgix.net/microsites/bit2021/sustainability/5_usa_one/thumbnail.jpg?auto=format&fit=min&w=80&h=60&q=72",
          title: "Best in Travel 2021",
          subtitle: "Featured",
          url: LPTV_URL,
        },
        items: [
          {
            title: "Globe Trekker",
            url: buildUrl(LPTV_URL, "/page/globe-trekker/"),
          },
          {
            title: "Planet Food",
            url: "https://tv.lonelyplanet.com/page/planet-food/",
          },
          {
            title: "Treks in a Wild World",
            url: "https://tv.lonelyplanet.com/page/treks-in-a-wild-world/",
          },
          {
            title: "Eat, Drink & Travel",
            url: "https://tv.lonelyplanet.com/page/food-and-drink/",
          },
          {
            title: "Across the Planet",
            url: "https://tv.lonelyplanet.com/page/across-the-planet/",
          },
          {
            title: "Lonely Planet Shorts",
            url: "https://tv.lonelyplanet.com/page/lonely-planet-shorts/",
          },
          {
            title: "Videos",
            url: VIDEO_URL,
          },
        ],
        call_to_action: {
          url: LPTV_URL,
          title: "Browse More Shows",
        },
      },
    },
    {
      title: "Stories",
      url: VIDEO_URL,
      mobileOrder: 3,
      submenu: {
        featured: {
          image:
            "https://lp-cms-production.imgix.net/2020-04/Hamm%20Street%20Art.jpg?auto=format&fit=min&w=80&h=60&q=72",
          title: "Covid travel updates",
          subtitle: "Featured",
          url: "https://www.lonelyplanet.com/landing/covid-19",
        },
        items: [
          {
            title: "Adventure",
            url:
              "https://www.lonelyplanet.com/articles/category/adventure-travel",
          },
          {
            title: "Family holidays",
            url:
              "https://www.lonelyplanet.com/articles/category/family-holidays",
          },
          {
            title: "Romance",
            url:
              "https://www.lonelyplanet.com/articles/category/honeymoon-and-romance",
          },
          {
            title: "Budget",
            url:
              "https://www.lonelyplanet.com/articles/category/travel-on-a-budget",
          },
          {
            title: "Foodie",
            url:
              "https://www.lonelyplanet.com/articles/category/food-and-drink",
          },
          {
            title: "Beaches, coasts and islands",
            url:
              "https://www.lonelyplanet.com/articles/category/beaches-coasts-and-islands",
          },
          {
            title: "Roadtrips",
            url: "https://www.lonelyplanet.com/articles/category/road-trips",
          },
          {
            title: "Art and culture",
            url:
              "https://www.lonelyplanet.com/articles/category/art-and-culture",
          },
        ],
        call_to_action: {
          url: "https://www.lonelyplanet.com/articles",
          title: "View all stories",
        },
      },
    },
    {
      title: "Bookings",
      url: "https://www.lonelyplanet.com/bookings",
      mobileOrder: 4,
      submenu: {
        featured: {
          image:
            "https://lp-cms-production.imgix.net/image_browser/LPE-menu-badge.jpg?auto=format&fit=min&w=80&h=60&q=72",
          title: "Lonely Planet Experiences",
          subtitle: "Featured",
          url: "https://www.lonelyplanet.com/experiences",
        },
        items: [
          {
            title: "Insurance",
            url: buildUrl(LP_URL, "travel-insurance"),
          },
          {
            title: "Hotels",
            url: buildUrl(LP_URL, "hotels"),
          },
          {
            title: "Flights",
            url: buildUrl(LP_URL, "flights"),
          },
          {
            title: "Multi-day tours",
            url: buildUrl(LP_URL, "adventure-tours"),
          },
          {
            title: "Tickets & activities",
            url: buildUrl(LP_URL, "sightseeing-tours"),
          },
          {
            title: "Car rental",
            url: buildUrl(LP_URL, "car-rental"),
          },
        ],
      },
    },
    {
      title: "Shop",
      url: SHOP_URL,
      isExternal: true,
      mobileOrder: 5,
    },
  ],
};

const getSignInItem = ({ includeTargetLink = true } = {}) => {
  const query = {
    client_id: AUTH_CLIENT_ID,
    scope: "openid",
    redirect_uri: buildUrl(AUTH_URL, "sso"),
    response_type: "code",
    prompt: "login",
  };

  if (typeof window !== "undefined") {
    if (has(window, "lp.auth.options.clientId")) {
      query.client_id = window.lp.auth.options.clientId || query.client_id;
    }

    if (includeTargetLink) {
      query.target_link_uri = window.location.href;
    }
  }

  return {
    title: "Sign in",
    url: buildUrl(AUTH_URL, { path: "oauth/authorize", query }),
  };
};

const getUserSettingsItem = (user) => ({
  title: "Settings",
  url: buildUrl(PROFILE_URL, `${user.id}/edit`),
});

const getUserProfileItem = (user) => ({
  title: "Profile",
  url: buildUrl(PROFILE_URL, `${user.username}`),
});

const getUserListsItem = (user) => ({
  title: "Lists",
  url: buildUrl(PROFILE_URL, `${user.username}/lists`),
});

const thornTreeItem = {
  title: "Thorn Tree",
  url: buildUrl(COMMUNITY_URL),
};

const messagesItem = {
  title: "Messages",
  url: buildUrl(COMMUNITY_URL, "messages"),
};

const signOutItem = {
  title: "Sign out",
  url: buildUrl(AUTH_URL, "users/sign_out"),
};

const getUserDesktopMenu = (user) => {
  const userSettingsItem = getUserSettingsItem(user);

  return {
    ...userSettingsItem,
    submenu: {
      items: [
        userSettingsItem,
        getUserProfileItem(user),
        getUserListsItem(user),
        thornTreeItem,
        messagesItem,
        signOutItem,
      ],
    },
  };
};

const getUserMobileMenu = (user) => ({
  items: [thornTreeItem, getUserListsItem(user), signOutItem],
});

const baseDesktopMenu = filterMenu(baseMenu, DESKTOP);
const baseMobileMenu = filterMenu(baseMenu, MOBILE);
baseMobileMenu.items.sort((a, b) => a.mobileOrder - b.mobileOrder);

export default {
  baseMenu,
  baseDesktopMenu,
  baseMobileMenu,
  getSignInItem,
  getUserDesktopMenu,
  getUserMobileMenu,
  getUserProfileItem,
  getUserSettingsItem,
};
